import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import NotFoundPage from "@/catchall";
import RootErrorBoundary from "@/components/universal/error-boundary";
import { AuthProvider } from "@/auth/auth-provider";
import { Toaster } from "@/components/ui/sonner";
import { HelpArea } from "@/components/universal/help-area";
import { Alert } from "@/contexts/alert-context";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()(
  {
    component: MainLayout,
    notFoundComponent: NotFoundPage,
    errorComponent: RootErrorBoundary,
  },
);

function MainLayout() {
  return (
    <AuthProvider>
      <Alert />
      <Outlet />
      <HelpArea />
      <Toaster richColors toastOptions={{ duration: 6000 }} theme="light" />
    </AuthProvider>
  );
}
